import { useEffect } from 'react';
import { useCustomizationStore } from 'common/services/customizations-service/service-store/service-store';
import { customizationsServiceStylesMapSelector } from 'common/services/customizations-service/service-store/selectors';
import { checkEqual } from 'common/helpers/checkEqual';
export var ThemeObserver = function () {
    var customizationStylesMap = useCustomizationStore(customizationsServiceStylesMapSelector, checkEqual);
    useEffect(function () {
        if (!customizationStylesMap)
            return;
        var rootStyles = document.documentElement.style;
        Object.entries(customizationStylesMap).forEach(function (_a) {
            var key = _a[0], value = _a[1].value;
            if (value)
                rootStyles.setProperty("--".concat(key), value);
        });
    }, [customizationStylesMap]);
    return null;
};
